import { render, staticRenderFns } from "./PerformanceItem.vue?vue&type=template&id=db33c004&scoped=true&"
import script from "./PerformanceItem.vue?vue&type=script&lang=ts&"
export * from "./PerformanceItem.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceItem.vue?vue&type=style&index=0&id=db33c004&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db33c004",
  null
  
)

export default component.exports